import React, {useEffect, useRef, useState} from "react";
import {Button, Card, Col, Container, Input, Row, Spinner, Tooltip,} from "reactstrap";
import {collection, deleteDoc, doc, getDoc, getDocs, increment, query, updateDoc, where} from "firebase/firestore";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import {getDb, multiselectDropdownStyle} from "util/Constants";
import ExportCsv from "../../components/ExportCSV";
import {MyVerticallyCenteredModal} from "../../components/Modal";
import {useParams} from "react-router-dom";
import {addUserInGame, sendInviteEmail} from "../../util/UploadUsers";
import Multiselect from "multiselect-react-dropdown";
import {cities} from "../../util/Cities";
import {UniversitiesList} from "../../util/UniversitiesList";
import classNames from "classnames";

const CandidateReport = ({signedInUser}) => {
    // states
    const [modalShow, setModalShow] = useState({show: false, rowId: null});
    const [data, setData] = useState([]);
    const [tempData, setTempData] = useState([]);
    const [search, setSearch] = useState("");
    const [selectedCities, setSelectedCities] = useState([]);
    const [selectedCgpa, setSelectedCgpa] = useState("");
    const [selectedInstitutes, setSelectedInstitutes] = useState([]);
    const [showing, setShowing] = useState("unShortlisted");
    const [allUsersFetched, setAllUsersFetched] = useState(false);
    const [eventData, setEventData] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipText, setTooltipText] = useState("Copy Link");
    const [loading, setLoading] = useState("fetching");
    const [maxUsers, setMaxUsers] = useState(signedInUser.maxUsers);
    const [currentUsers, setcurrentUsers] = useState(signedInUser.usersCount);
    const [adminDoc, setAdminDoc] = useState({});

    const selectedCityRef = useRef([]);
    const selectedInstituteRef = useRef([]);
    const selectedCgpaRef = useRef([]);
    const adminRef = doc(getDb(), "admins", signedInUser.uid);

    const {eventId} = useParams();

    useEffect(() => {
        console.log(signedInUser, "Signed in user");
        getAdmin().then(response => {
            setMaxUsers(response.maxUsers);
            setcurrentUsers(response.usersCount);
            setAdminDoc(response);
        })
        getUserData().then((_users) => {
            setData(_users);
            setTempData(_users);
            setLoading(null);
        });
        getEvent().then(_event => {
            setEventData(_event);
        })
    }, []);
    useEffect(() => {
        if (showing === "all") {
            if (!allUsersFetched) {
                setLoading("fetching");
                getAllUsers().then((_users) => {
                    setData([...data, ..._users]);
                    setTempData([...tempData, ..._users]);
                    setLoading(null)
                    setAllUsersFetched(true);
                });
            } else {
                setTempData(data);
            }
        } else {
            const userPool = data.filter(_user => _user.shortlisted === false);
            setTempData(userPool);
        }
    }, [showing]);
    useEffect(() => {
        const userPool = showing === "all" ? data : data.filter(_user => _user.shortlisted === false);
        if (search) {
            let filterData = userPool;
            filterData = filterData.filter((item) => {
                if (item.name || item.email || item.degree) {
                    if (
                        item.name
                            .toString()
                            .toLowerCase()
                            .includes(search.toLowerCase()) ||
                        item.email
                            .toString()
                            .toLowerCase()
                            .includes(search.toLowerCase()) ||
                        item.degree
                            .toString()
                            .toLowerCase()
                            .includes(search.toLowerCase())
                    ) {
                        return item;
                    }
                }
            });
            setTempData(filterData);
        } else {
            setTempData(userPool);
        }
    }, [search]);
    useEffect(() => {
        console.log(currentUsers, "currentUsers");
        console.log(maxUsers, "Max users");
    }, [currentUsers, maxUsers]);

    const shortlistUser = async (userData) => {
        if (currentUsers < maxUsers) {
            setLoading("shortlisting");
            const id = userData.firebaseId
            const userRef = doc(getDb(), "candidates", id);
            await updateDoc(userRef, {
                shortlisted: true,
            });
            await addUserInGame(userData, eventId);
            await sendInviteEmail(userData?.email, eventId);
            const userPool = tempData.map(_user => {
                if (_user.firebaseId === id) {
                    _user.shortlisted = true;
                }
                return _user;
            });
            setTempData(userPool);
            const dataPool = data.map(_user => {
                if (_user.firebaseId === id) {
                    _user.shortlisted = true;
                }
                return _user;
            });
            setData(dataPool);
            setLoading(null);
            await Swal.fire({
                icon: "success",
                title: "Success",
                text: "User shortlisted successfully!",
            });
            setcurrentUsers(currentUsers + 1);
            await updateDoc(adminRef, {
                usersCount: increment(1)
            });
        } else {
            await Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "You have reached your maximum users limit. Please upgrade your plan to add more users.",
            });
        }
    };
    const cancelShortList = async (id) => {
        // remove extention from filename
        const userRef = doc(getDb(), "candidates", id);
        await updateDoc(userRef, {
            shortlisted: false,
        });
        await Swal.fire({
            icon: "success",
            title: "Success",
            text: "User removed from shortlist!",
        });
    };
    const deleteUser = async (id) => {
        // show confirmation
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
            reverseButtons: true,
        });
        // console.log(result.isConfirmed)
        if (result.isConfirmed) {
            // console.log(`befffffff`, filename);
            // const id = filename.split(".").slice(0, -1).join(".");
            // console.log(`after`,id);
            const userRef = doc(getDb(), "candidates", id);
            await deleteDoc(userRef).then(async () => {
                await Swal.fire("Deleted", "Your file has been deleted!", "success");
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            await Swal.fire("Cancelled", "User is safe and not deleted!", "error");
        }
    };
    const columns = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Email",
            selector: (row) => row.email,
            sortable: true,
        },
        {
            name: "Gender",
            selector: (row) => row.gender,
            sortable: true,
        },
        {
            name: "City",
            selector: (row) => row.city,
            sortable: true,
        },
        {
            name: "Shortlisted",
            cell: (row) =>
                row.shortlisted ? (
                    <i className="fas fa-check text-success"></i>
                ) : (
                    <i className="fas fa-times text-danger"></i>
                ),
            sortable: true,
        },
        {
            name: "Degree",
            selector: (row) => row?.degree,
            sortable: true,
        },
        // {
        //     name: "Applied Date",
        //     selector: (row) =>
        //         row.timestamp ? row.timestamp.toDate().toDateString() : "",
        //     sortable: true,
        // },
        {
            name: "Action",
            cell: (row, ind) => (
                <>
                    <Button
                        // data-toggle="modal"
                        // data-target="#exampleModal"
                        color="warning"
                        size="sm"
                        title="View details"
                        onClick={() => setModalShow({show: true, rowId: ind})}
                    >
                        <i className="fas fa-eye"></i>
                    </Button>
                    <Button
                        color="primary"
                        size="sm"
                        title="shortlist candidate"
                        disabled={loading !== null || row.shortlisted === true}
                        onClick={() => {
                            shortlistUser(row);
                        }}
                    >
                        <i className="fas fa-check"></i>
                    </Button>
                    <Button
                        color="danger"
                        size="sm"
                        title="delist candidate"
                        onClick={() => {
                            cancelShortList(row.firebaseId);
                        }}
                    >
                        <i className="fas fa-ban"></i>
                    </Button>
                    <Button

                        color="danger"
                        size="sm"
                        title="delete candidate data"
                        onClick={() => {
                            deleteUser(row.firebaseId);
                        }}
                    >
                        <i className="fas fa-trash-alt"></i>
                    </Button>
                </>
            ),
        },
    ];
    const clearFilter = (e) => {
        e.preventDefault();
        setSearch("");
        selectedCityRef.current.resetSelectedValues();
        selectedInstituteRef.current.resetSelectedValues();
        selectedCgpaRef.current.resetSelectedValues();
        setShowing("unShortlisted");
        const userPool = data.filter(_user => _user.shortlisted === false);
        setTempData(userPool);
    };
    const getUserData = async () => {
        let tempData = [];
        const q = query(collection(getDb(), "candidates"),
            where("companyId", "==", eventId),
            where("shortlisted", "==", false)
        )
        const allDocs = await getDocs(q);
        allDocs.forEach((doc) => {
            tempData.push({...doc.data(), firebaseId: doc.id});
        });
        return tempData;
    };
    const getAllUsers = async () => {
        let tempData = [];
        const q = query(collection(getDb(), "candidates"),
            where("companyId", "==", eventId),
            where("shortlisted", "==", true)
        )
        const allDocs = await getDocs(q);
        allDocs.forEach((doc) => {
            tempData.push({...doc.data(), firebaseId: doc.id});
        });
        return tempData;
    };
    const applyFilter = (e) => {
        let filterData = showing === "all" ? data : tempData;
        if (selectedCities.length > 0) {
            filterData = filterData.filter((item) => selectedCities.includes(item.city));
        }
        if (selectedInstitutes.length > 0) {
            filterData = filterData.filter((item) => selectedInstitutes.includes(item.institute));
        }
        if (selectedCgpa) {
            const [value1, value2] = selectedCgpa.split('-').map(Number);
            filterData = filterData.filter((item) => item.cgpa > value1 && item.cgpa < value2);
        }
        setTempData(filterData);
    };
    const toggle = () => setTooltipOpen(!tooltipOpen);
    const handleCopy = () => {
        console.log(window.location.origin);
        let link = `${window.location.origin}/candidate-flow`;
        navigator.clipboard.writeText(link + `/${eventId}`);
        setTooltipText('Copied!');
        setTimeout(() => {
            toggle()
        }, 1000);
        setTimeout(() => {
            setTooltipText('Copy Link');
        }, 2000)
    };
    const removeFilter = (list, filter) => {
        switch (filter) {
            case "cities" :
                setSelectedCities(list);
                break;
            case "cgpa" :
                setSelectedCgpa("");
                break;
            case "institute":
                setSelectedInstitutes(list);
                break;
        }
    };
    const getEvent = async () => {
        const docRef = doc(getDb(), "Events", eventId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data();
        }
    };
    const getAdmin = async () => {
        const adminSnap = await getDoc(adminRef);
        if (adminSnap.exists()) {
            return adminSnap.data();
        }
    }

    return (
        <>
            <Container fluid>
                <div className="">
                    <a className="warning-text-color font-weight-600" role="button" id="copy"
                       onClick={() => handleCopy()}>
                        Copy User Registration Link</a>
                    <Tooltip
                        placement="right"
                        isOpen={tooltipOpen}
                        target="copy"
                        toggle={toggle}
                        className="custom-tooltip"
                    >
                        {tooltipText}
                    </Tooltip>
                </div>
                <Row className="mt-3">
                    <Col className="mb-5 mb-xl-0" xl="12">
                        <h1 className="mb-0 custom-font letterSpacing">Filters</h1>
                        {/*Filters Row*/}
                        <Row className="align-items-center ">
                            <Col lg="2">
                                {/* <Label>City</Label> */}
                                <Multiselect
                                    ref={selectedCityRef}
                                    className="form-control-alternative filters-sub"
                                    isObject={false}
                                    showArrow={true}
                                    placeholder="City"
                                    options={cities.map(city => city.value)}
                                    closeIcon="cancel"
                                    onSelect={(list, item) => setSelectedCities(list)}
                                    onRemove={(list, item) => removeFilter(list, "cities")}
                                    style={multiselectDropdownStyle}
                                />
                            </Col>
                            <Col lg="2">
                                {/* <Label>Insttiue</Label> */}
                                <Multiselect
                                    ref={selectedInstituteRef}
                                    className="form-control-alternative filters-sub"
                                    isObject={false}
                                    showArrow={true}
                                    placeholder="Institute"
                                    options={UniversitiesList.map(institute => institute.value)}
                                    closeIcon="cancel"
                                    onSelect={(list, item) => setSelectedInstitutes(list)}
                                    onRemove={(list, item) => removeFilter(list, "institute")}
                                    style={multiselectDropdownStyle}
                                />
                            </Col>
                            <Col lg="2">
                                {/* <Label>CGPA</Label> */}
                                <Multiselect
                                    ref={selectedCgpaRef}
                                    className="form-control-alternative filters-sub"
                                    isObject={false}
                                    showArrow={true}
                                    singleSelect={true}
                                    selectionLimit={1}
                                    placeholder="CGPA"
                                    options={["1-2", "2-3", "3-4"]}
                                    closeIcon="cancel"
                                    onSelect={(list, item) => {
                                        setSelectedCgpa(item);
                                    }}
                                    onRemove={(list, item) => removeFilter(list, "cgpa")}
                                    style={multiselectDropdownStyle}
                                />
                            </Col>
                            <Col lg="2" className="d-flex justify-content-end d-flex ">
                                <Button color="danger" onClick={clearFilter}>
                                    Clear
                                </Button>
                                <Button color="primary" onClick={applyFilter}>
                                    Apply
                                </Button>
                            </Col>
                        </Row>
                        {/*Toggle Button*/}
                        <div className="d-flex justify-content-start mt-4 mb-2 fs-14">
                            <label
                                htmlFor="site_state"
                                className={classNames("fw-bold", {
                                    "text-muted": showing !== "unShortlisted",
                                })}
                            >
                                Un-shortlisted
                                {/*<span className="badge bg-primary small ms-2">discounted</span>*/}
                            </label>
                            <label className="switch mx-2">
                                <input
                                    id="site_state"
                                    type="checkbox"
                                    onChange={({target}) => {
                                        target.checked
                                            ? setShowing("all")
                                            : setShowing("unShortlisted");
                                    }}
                                    checked={showing === "all"}
                                />
                                <span className="switch-slider always-on round"/>
                            </label>
                            <label
                                htmlFor="site_state"
                                className={classNames("fw-bold", {
                                    "text-muted": showing !== "all",
                                })}
                            >
                                All
                            </label>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className="mb-5 mb-xl-0" xl="12">
                        <Row className="align-items-center mb-2">
                            <Col lg="4">
                                <h3 className="mb-0">Users</h3>
                            </Col>
                            <Col lg="8">
                                <Row>
                                    {/* search name */}
                                    <Col md="4"/>
                                    <Col md="5" className="mt-2">
                                        <Input
                                            className="form-control-alternative filters-sub"
                                            placeholder="Search By Name, Email or Degree"
                                            onChange={(e) => {
                                                setSearch(e.target.value);
                                            }}
                                            value={search}

                                        />
                                    </Col>
                                    <Col md="3" className="mt-2">
                                        <ExportCsv
                                            className="btn btnColor custom-font"
                                            data={tempData}
                                            fileName="users.csv"
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        {/* <!-- Modal --> */}
                        {modalShow.show && (
                            <MyVerticallyCenteredModal
                                show={modalShow.show}
                                onHide={() => setModalShow({show: false, rowId: null})}
                                data={tempData}
                                id={modalShow.rowId}
                            />
                        )}
                        {loading === "fetching" ?
                            <div className="text-center mt-5">
                                <Spinner
                                    color={'primary'}
                                    size={''}
                                >
                                    Loading...
                                </Spinner>
                            </div>
                            :
                            // DataTable
                            <Card>
                                <DataTable
                                    pagination
                                    columns={columns}
                                    data={tempData}
                                    highlightOnHover
                                    pointerOnHover
                                    paginationPerPage={10}
                                    paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                    paginationComponentOptions={{
                                        rowsPerPageText: "Rows per page:",
                                        rangeSeparatorText: "of",
                                        noRowsPerPage: false,
                                        selectAllRowsItem: true,
                                        selectAllRowsItemText: "All",
                                    }}
                                    // actions={
                                    //   <>
                                    //     <ExportCsv data={tempData} fileName="users.csv" />
                                    //   </>
                                    // }
                                />
                            </Card>
                        }
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default CandidateReport;
